import PropTypes from 'prop-types';

import {Layer, measureText} from "./Canvas.jsx";
import deepEqual from "lib/deepEqual";
import getDefaultFont from "lib/getDefaultFont";

const LEGEND_ITEM_HEIGHT = 20;
const FONT_SIZE = 16;

const truncate = txt => txt.length > 25 ? txt.slice(0, 22) + "..." : txt;

const EMPTY_TEXT = "(none)";

export const estimateSize = (groups, maxHeight) => {
    let drawHeight = LEGEND_ITEM_HEIGHT * groups.length;

    if (drawHeight > maxHeight || groups.length === 0) {
        return {width: 0, height: 0};
    }

    let widths = groups.map(({name}) => measureText(truncate(name || EMPTY_TEXT), {size: FONT_SIZE}));

    let drawWidth = Math.max(...widths);

    return {
        width: Math.round(drawWidth + LEGEND_ITEM_HEIGHT + 4),
        height: drawHeight
    };
};

export default class Legend extends Layer {
    static propTypes = {
        groups: PropTypes.array,
        colors: PropTypes.object,
        keys: PropTypes.object,
        maxHeight: PropTypes.number,
        autoHide: PropTypes.bool
    }

    static defaultProps = {
        groups: [],
        maxHeight: Infinity,
        autoHide: true
    }

    static displayName = 'Legend';

    getHoverData({x, y}){
        let {groups} = this.props;
        let i = Math.floor(y / LEGEND_ITEM_HEIGHT);
        let group = groups[i];
        let {name, value} = this.props.keys;
        return group ? {[name]: group.name, [value]: group.value} : null;
    }

    getEstimatedSize() {
        let {groups, maxHeight} = this.props;
        return estimateSize(groups, maxHeight);
    }
    
    doDraw() {
        let {groups, colors} = this.props;
        let ctx = this.getCtx();

        let size = this.getEstimatedSize();
        this.setSize(size);

        if (size.height === 0) {
            return;
        }

        let rectMargin = 4;
        ctx.font = `normal ${FONT_SIZE}px ${getDefaultFont()}`;
        ctx.textBaseline = 'middle';
        
        for (let i = 0; i < groups.length;  i++) {
            let group = groups[i];

            ctx.save();

            ctx.translate(0, LEGEND_ITEM_HEIGHT * i);
            ctx.fillStyle = colors.get(group.name);

            ctx.beginPath();
            ctx.fillRect(rectMargin, rectMargin, LEGEND_ITEM_HEIGHT - rectMargin * 2, LEGEND_ITEM_HEIGHT - rectMargin * 2);
            ctx.fill();
            ctx.closePath();

            ctx.fillStyle = "black";
            ctx.fillText(truncate(group.name || EMPTY_TEXT) , LEGEND_ITEM_HEIGHT, LEGEND_ITEM_HEIGHT / 2);

            ctx.restore();
        }
    }

    componentWillReceiveProps(nextProps) {
        let groupNames = this.props.groups.map(({name}) => name);
        let nextGroupNames = nextProps.groups.map(({name}) => name);

        const isHidden = ({maxHeight, autoHide}) => {
            let {height} = this.getEstimatedSize();
            return height > maxHeight;
        };

        if (this.props.colors !== nextProps.colors || !deepEqual(groupNames, nextGroupNames) ||
            this.props.maxHeight !== nextProps.maxHeight && isHidden(this.props) !== isHidden(nextProps)
        ) {
            this.markDirty();
        }
    }
}



// WEBPACK FOOTER //
// ./src/kpi/charts/Legend.jsx